import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormsModule, ReactiveFormsModule, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ManageCardsService } from '../manage-cards.service';
import { LoggerService } from '../../../logger/logger.service';

// tslint:disable-next-line:max-line-length
// const CARD_REGEX = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
const CARD_REGEX = /^4[0-9]{3}\-[0-9]{4}\-[0-9]{4}\-[0-9]{1}(?:[0-9]{3})?$|^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$|^3[47][0-9]{2}\-[0-9]{6}\-[0-9]{5}$|^6(?:011|5[0-9]{2})\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$/;
const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const CVV_REGEX = /^[0-9]{3,4}$/;
const EXPIRATIONDATE_REGEX = /^(0[1-9]|1[0-2])\/[0-9]{2}$/;

@Component({
  selector: 'app-add-new-card',
  templateUrl: './add-new-card.component.html',
  styleUrls: ['./add-new-card.component.css']
})
export class AddNewCardComponent implements OnInit {
  public cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public expMask = [/\d/, /\d/, '\/', /\d/, /\d/];

  cardFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(CARD_REGEX)]);

  expirationDateFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(EXPIRATIONDATE_REGEX)]);

  ccvFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(CVV_REGEX)]);

  billingZipCodeFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(ZIPCODE_REGEX)]);

  public card_detail: Object;
  public credit_debit_number;
  private card_number;
  public expiration_date;
  public ccv;
  public billing_zip_code;
  public add_money_valid;
  public visa_valid: boolean; // 4.
  public master_valid: boolean; // 51 through 55.
  public american_express_valid: boolean; // 37
  public discover_valid: boolean; // 6011 or 65.
  public card_ending_digit: string;
  public username: string;
  public card_max_length: number;
  public card_type: string;
  public card_name: string;
  public img: string;
  public save_card_btn: string;
  private token: string;
  public retries: number;
  public is_readonly_retry:boolean;

  constructor(private sharedService: SharedService, private router: Router, private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute, private manageCardsService: ManageCardsService, private logger: LoggerService) {
    this.sharedService.setHeaderTitle('add_new_card');
    this.sharedService.setHeaderErrorMessage('add_new_card', false, 'notification error', '');
    this.token = this.localStorageService.get('token');
    this.retries = 0;
    this.is_readonly_retry = true;

    if (this.token != null) {
      this.sharedService.verifyToken({ 'token': this.token })
        .then(res => {
          if (res.status === 'success' && res.isTerminated === false) {
            const person = res.results[0]['personal'][0];

            // Used for dataLayer.push
            const dataLayerAccountInfo = res.results[0]['personal'];

            var dataLayerEvent = 'add new card';
            (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': dataLayerAccountInfo[0].id.toString(), 'accountNumber': dataLayerAccountInfo[0].accountNumber.toString() });

            this.username = person['username'];
            const that = this;
            setTimeout(function () {
              that.sharedService.setHeaderUserLoggedIn('add_new_card', true, person);
            }, 10);
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.set('returnUrl', 'manage_payment_methods/new_card');
            this.router.navigate(['./sign-in']);
          }
        });
    } else {
      this.localStorageService.set('returnUrl', 'manage_payment_methods/new_card');
      this.router.navigate(['./sign-in']);
    }
    this.add_money_valid = false;
    this.visa_valid = false;
    this.master_valid = false;
    this.american_express_valid = false;
    this.discover_valid = false;
    this.card_type = 'Credit Card';
    this.card_name = '';
    this.save_card_btn = this.sharedService.getSaveTranslation();

  }

  unmaskData(data: string) {
    if (data != null && data.trim()!="") {
      return data.replace(/[\s\(\)\-]/g, '');
    } else {
      return "";
    }
  }

  addMoneyValidate(credit_card: any) {
    if (this.credit_debit_number !== undefined) {
      this.card_number = this.unmaskData(this.credit_debit_number);
      if (this.card_number.match(/^4/)) {
        this.visa_valid = true;
        this.card_name = 'Visa';
        this.american_express_valid = false;
        this.discover_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/visa.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.card_number.match(/^(5[1-5]|2[2-7])/)) {
        this.master_valid = true;
        this.card_name = 'MasterCard';
        this.visa_valid = false;
        this.american_express_valid = false;
        this.discover_valid = false;
        this.img = 'assets/images/masterCard.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.card_number.match(/^3[47]/)) {
        this.american_express_valid = true;
        this.card_name = 'American Express';
        this.visa_valid = false;
        this.discover_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/americanExpress.png';
        this.card_max_length = 17;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.card_number.match(/^6([045]|22)/)) {
        this.discover_valid = true;
        this.card_name = 'Discover';
        this.visa_valid = false;
        this.american_express_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/discover.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else {
        this.visa_valid = false;
        this.card_name = '';
        this.master_valid = false;
        this.american_express_valid = false;
        this.discover_valid = false;
      }
    }
    if (this.card_number !== '' && this.expiration_date !== '' && this.ccv !== '' &&
      this.billing_zip_code !== '' && this.card_number !== undefined &&
      this.expiration_date !== undefined && this.ccv !== undefined && this.billing_zip_code !== undefined
      && this.card_number.length > 12 && this.ccv.length > 2 && this.ccv.match(CVV_REGEX) &&
      this.billing_zip_code.match(ZIPCODE_REGEX) && this.credit_debit_number.match(CARD_REGEX) &&
      this.expiration_date.match(EXPIRATIONDATE_REGEX)) {
      this.add_money_valid = true;
      if (credit_card.keyCode === 13) {
        document.getElementById('next_pay').click();
      }
    } else {
      this.add_money_valid = false;
    }
  }

  saveCard() {
    this.sharedService.setHeaderErrorMessage('add_new_card', false, 'notification error', '');
    if (this.card_name !== '') {
      // this.card_ending_digit = this.credit_debit_number.substring(this.credit_debit_number.length - 4, this.credit_debit_number);
      let card_digit_groups = this.credit_debit_number.split('-');
      this.card_ending_digit = card_digit_groups[card_digit_groups.length - 1];

      this.save_card_btn = 'Saving...';
      this.add_money_valid = false;
      this.card_detail = {
        'CardNumber': this.card_number,
        'ExpireMonthYear': this.expiration_date,
        'CCV': this.ccv,
        'CardZipCode': this.billing_zip_code,
        'token': this.token,
        'cardName': this.card_name,
        'cardType': this.card_type,
        'isRetry' : this.retries==0 ? false : true
      }
      let methodName = this.constructor.name + '.saveCard';
      this.manageCardsService.saveCard(this.card_detail).then(res => {
        this.card_detail['CardNumber'] = "[masked]-" + this.card_detail['CardNumber'].substr(this.card_detail['CardNumber'].length - 4);
        this.card_detail['ExpireMonthYear'] = "[masked]";
        this.card_detail['CCV'] = "[masked]";
        this.card_detail['CardZipCode'] = "[masked]";
        this.card_detail['token'] = "[masked]";
        let logObj = {
          method: methodName,
          request: this.card_detail,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        this.add_money_valid = true;
        this.save_card_btn = this.sharedService.getSaveTranslation();
        if (res.status === 'success') {
          this.router.navigate(['./manage_payment_methods']);
        } else {
          if (this.retries==0)
            this.retries++;
          else
          {
              this.is_readonly_retry = false;
              this.add_money_valid = false;
          }
          window.scrollTo(0, 0);
          this.sharedService.setHeaderErrorMessage('add_new_card', true, 'notification error', res.message);
        }
      }, (error) => {
        let logObj = {
          method: methodName,
          request: this.card_detail,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex) => {
        let logObj = {
          method: methodName,
          request: this.card_detail,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
    } else {
      window.scrollTo(0, 0);
      this.sharedService.setHeaderErrorMessage('add_new_card', true, 'notification error', 'Invalid Card');
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/manage-cards/add-new-card/add-new-card.component.ts